var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMailSecondary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_232_77)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_232_77",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0H0V14H14V0Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_232_77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.4 12.3667C1.015 12.3667 0.685533 12.2297 0.4116 11.9558C0.1372 11.6814 0 11.3517 0 10.9667V2.56663C0 2.18163 0.1372 1.85216 0.4116 1.57823C0.685533 1.30383 1.015 1.16663 1.4 1.16663H12.6C12.985 1.16663 13.3147 1.30383 13.5891 1.57823C13.863 1.85216 14 2.18163 14 2.56663V10.9667C14 11.3517 13.863 11.6814 13.5891 11.9558C13.3147 12.2297 12.985 12.3667 12.6 12.3667H1.4ZM7 7.46663L1.4 3.96663V10.9667H12.6V3.96663L7 7.46663ZM7 6.06663L12.6 2.56663H1.4L7 6.06663ZM1.4 3.96663V2.56663V10.9667V3.96663Z",
    fill: "#666666"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_232_77"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMailSecondary);
export default __webpack_public_path__ + "static/media/ic-mail-secondary.ca8a4fa4d418bd7586f7b753fc36b23a.svg";
export { ForwardRef as ReactComponent };